import React from 'react';
import styled from 'styled-components';

export const MenuButton = () => {
    const handleClick = () => {
        window.location.href = "/menu";
    }
  return (
    <Container onClick={handleClick}>MENU</Container>
  )
}

const Container = styled.button`
    font-size: 1.25rem;
    font-family: "Roboto", sans-serif;
    padding: 1rem 2rem;
    color: #cbb16d;
    border: 3px solid #cbb16d;
    background: transparent;
    border-radius: 1rem;
`;
